// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__G6wp7","collapsedRow":"styles_collapsedRow__F6mya","a":"styles_a__s1BHE"};